<div class="center-screen">
  <img class="bigger-icon" src="/assets/img/Error.svg"/>
  <div class="text-center">
    <h1 class="standard-heading">The page you are looking for can't be found, sorry about that!</h1>
    <div class="text-center">You will be returned to your dashboard in a few seconds</div>
  </div>
</div>
